import { useErrorBoundaryContext } from 'src/components/error-boundary/error-provider';

const useHandleError = () => {
  const { showBoundary } = useErrorBoundaryContext(); // ErrorBoundary로 에러 전달하는 함수

  return (cb: any) =>
    async (...args: any) => {
      try {
        const result = await cb(...args);
        return result;
      } catch (error) {
        showBoundary(error); // 에러 발생 시 ErrorBoundary로 전달
      }
    };
};

export default useHandleError;
